import { Component } from '@angular/core';

@Component({
  selector: 'app-tiktok-icon',
  templateUrl: 'tiktok-icon.component.svg',
  standalone: true,
})
export class TiktokIconComponent {
}

